import { useState } from "react";
import useAuthStore from "../../../store/AuthStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import NotificationIcon from "./NavbarMenu/NotificationIcon";
import LogoutIcon from "./NavbarMenu/LogoutIcon";
import ProfileIcon from "./NavbarMenu/ProfileIcon";
import Dropdown from "../../UI/DropDown";
import MicroProfile from "../../user/MicroProfile";

const Navbar = ({
  toggleMenu,
  title,
  menuStatus,
  notificationCount,
  profileTitle,
  children,
}) => {
  const [assetDropDown, setAssetDropdown] = useState(false);
  const dropDownToggleHandler = () => setAssetDropdown(!assetDropDown);

  const { logout, user } = useAuthStore();
  const logoutHandler = () => {
    logout();
  };
  return (
    <>
      <nav className="flex justify-between items-center pl-6 pr-2  py-2 md:py-4 bg-gray-900 text-white shadow-md fixed left-0 top-0 w-full z-40">
        <div className="flex gap-10 -ml-3">
          <button className="block md:hidden w-[10px]" onClick={toggleMenu}>
            {!menuStatus ? (
              <FontAwesomeIcon icon={faBars} size="2x" />
            ) : (
              <FontAwesomeIcon
                icon={faTimes}
                className="hover:text-red-500"
                size="2x"
              />
            )}
          </button>
          <h1 className="text-l mr-2 text-center md:text-2xl font-bold">
            {title || "Admin Panel"}
          </h1>
        </div>
        <ul className="flex gap-2 items-end justify-end">
          {children}
          <NotificationIcon count={notificationCount} />
          <Dropdown
            onToggle={dropDownToggleHandler}
            assetDropdown={assetDropDown}
            modified={true}
            title={<MicroProfile username={user?.username || profileTitle} />}
          >
            <div className="flex flex-col gap-3 justify-evenly p-4 w-1/2">
              <ProfileIcon onToggle={dropDownToggleHandler}/>
              <LogoutIcon onLogout={logoutHandler} />
            </div>
          </Dropdown>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
